import {
  Box,
  Container,
  Grid,
  Stack,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import { customStyles } from "./index.styles";
import { serviceList, CONTACT_INFO } from "../../utils/constants";
import { Link, useNavigate } from "react-router-dom";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import { sharedStyles } from "../../utils/sharedStyles";

const Footer = () => {
  const navigate = useNavigate();

  const handleServiceClick = (serviceId: string) => {
    navigate(`/service/${serviceId}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box sx={customStyles.mainBox}>
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          {/* Company Info Section */}
          <Grid item xs={12} sm={6} md={4}>
            <Stack spacing={2}>
              <Box sx={customStyles.logoSection}>
                <img
                  alt="logo"
                  width={60}
                  style={customStyles.image}
                  src={`${process.env.PUBLIC_URL}/images/tabLogo.png`}
                />
                <Typography sx={customStyles.companyName}>
                  Radiant Property Management
                </Typography>
              </Box>

              <Typography sx={customStyles.description}>
                Professional commercial cleaning and property services in
                Melbourne. Over a decade of experience delivering exceptional
                quality.
              </Typography>

              {/* Social Media */}
              <Box>
                <Typography sx={customStyles.sectionTitle}>
                  Follow Us
                </Typography>
                <IconButton
                  sx={customStyles.socialIcon}
                  href={CONTACT_INFO.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookIcon />
                </IconButton>
              </Box>
            </Stack>
          </Grid>

          {/* Our Services Section */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography sx={customStyles.sectionTitle}>Our Services</Typography>
            <Stack spacing={1.5} mt={2}>
              {serviceList.slice(0, 8).map((service) => (
                <Typography
                  key={service.id}
                  sx={customStyles.serviceLink}
                  onClick={() => handleServiceClick(service.id)}
                >
                  {service.name}
                </Typography>
              ))}
            </Stack>
          </Grid>

          {/* Contact Info Section */}
          <Grid item xs={12} sm={12} md={4}>
            <Typography sx={customStyles.sectionTitle}>Contact Us</Typography>
            <Stack spacing={2} mt={2}>
              <Box sx={sharedStyles.contactItem}>
                <LocationOnIcon sx={sharedStyles.contactIcon} />
                <Box>
                  <Typography sx={customStyles.contactText}>
                    {CONTACT_INFO.address.line1}
                  </Typography>
                  <Typography sx={customStyles.contactText}>
                    {CONTACT_INFO.address.line2}
                  </Typography>
                  <Typography sx={customStyles.contactText}>
                    {CONTACT_INFO.address.line3}
                  </Typography>
                  <Typography sx={customStyles.contactText}>
                    {CONTACT_INFO.address.line4}
                  </Typography>
                </Box>
              </Box>

              <Box sx={sharedStyles.contactItem}>
                <PhoneIcon sx={sharedStyles.contactIcon} />
                <Typography
                  component="a"
                  href={`tel:${CONTACT_INFO.phone}`}
                  sx={sharedStyles.contactLink}
                >
                  {CONTACT_INFO.phoneDisplay}
                </Typography>
              </Box>

              <Box sx={sharedStyles.contactItem}>
                <EmailIcon sx={sharedStyles.contactIcon} />
                <Typography
                  component="a"
                  href={`mailto:${CONTACT_INFO.email}`}
                  sx={sharedStyles.contactLink}
                >
                  {CONTACT_INFO.email}
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        {/* Bottom Bar */}
        <Divider sx={customStyles.divider} />

        <Box sx={customStyles.bottomBar}>
          <Typography sx={customStyles.copyrightText}>
            © {new Date().getFullYear()} Radiant Property Management. All Rights
            Reserved.
          </Typography>

          <Stack
            direction="row"
            spacing={3}
            sx={customStyles.bottomLinks}
          >
            <Link to="/about" style={customStyles.link}>
              <Typography sx={customStyles.bottomLinkText}>About Us</Typography>
            </Link>
            <Link to="/contact" style={customStyles.link}>
              <Typography sx={customStyles.bottomLinkText}>Contact</Typography>
            </Link>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
